export default class BalanceNotificationsService {

    [x: string]: any; 
 	 static $inject = ['AuthService','ModalService','BalanceNotifications'];
    constructor(AuthService, ModalService, BalanceNotifications) {
        this.BalanceNotifications = BalanceNotifications;
        this.AuthService = AuthService;
        this.ModalService = ModalService;
    }

    notifyIfRechargeFailed() {
        if (this.AuthService.hasPermission("PLANS_PERMISSION"))
            this.BalanceNotifications.recharge({}, {}, (response) => {
                if (response.lastRechargeFailed) this.showLastRechargeFailedModal()
            })
    }

    showLastRechargeFailedModal() {
        if (this.AuthService.hasPermission("CHANGE_BILLING_PERMISSION")) {
            this.ModalService.showModalConfirm({title: "SETTINGS.AUTO_RECHARGE.LAST_FAILED"})
                .then(() => this.BalanceNotifications.resetRechargeFailed());
        }
    }
}
